<template>
    <vizit-one ref="aboutUs" :url="qrUrl" @focusin="onFocus" @focusout="onFocusOut" />
</template>

<script setup lang="ts">
    import { useResources } from "@/composables/useResources";
    import {type Ref, ref, onBeforeMount, onBeforeUnmount, onMounted} from 'vue';
    import type { VizitOneRef } from "@/components/VizitOne/types";
    import { useRouter } from 'vue-router';
    import { linkItems } from "@/components/Header/types/LinkItemsCollection";
    import type { AxiosError } from 'axios';
    import { Logger } from '@/utils';
    
    const router = useRouter();
    const { $navigator } = useNuxtApp();
    const emit = defineEmits(['ready', 'start']);
    const qrUrl: Ref<string> = ref('');
    const aboutUs: Ref<VizitOneRef | null> = ref(null);
    const isRegKeyListeners: Ref<boolean> = ref(false);

    const setQrUrl = (value: string) => {
        qrUrl.value = value;
    };

    const loadData = () => {
        emit("start");
        useResources('about').then((getQrUrlTemplate: string) => {
            setQrUrl(getQrUrlTemplate);
            emit("ready");
        }).catch((error) => {
            Logger.captureError(error as AxiosError | Error);
        });
    };

    const setSelfFocused = () => {
        if (aboutUs.value) {
            aboutUs.value.focusToCatcher();
        } 
        onFocus();
    };
    const registerKeyListeners = () => {
        if (!isRegKeyListeners.value) {
            $navigator.on("keypress:left", goToBack);
            $navigator.on("keypress:back", goToBack);
            isRegKeyListeners.value = true;
        }
    };
    const unregisterKeyListeners = () => {
        if (isRegKeyListeners.value) {
            $navigator.off("keypress:left", goToBack);
            $navigator.off("keypress:back", goToBack);
            isRegKeyListeners.value = false;
        }
    };
    const goToBack = () => {
        router.push(linkItems.settings.routerPath);
    };

    const onFocus = () => {
        registerKeyListeners();
    };
    const onFocusOut = () => {
        unregisterKeyListeners();
    };

    onMounted(() => {
        setSelfFocused();
    });

    onBeforeMount(() => {
        loadData();
    });

    onBeforeUnmount(() => {
        unregisterKeyListeners();
    });
</script>
